import creator from '@utils/creator.js';

import FAQPage from '@components/FAQPage';

function ClrzAppInit() {
	ClrzApp.FAQPage = creator(FAQPage.selectors.el, FAQPage);
}

ClrzAppInit();
